import { render, staticRenderFns } from "./equipHistory.vue?vue&type=template&id=68616c28&scoped=true"
import script from "./equipHistory.vue?vue&type=script&lang=js"
export * from "./equipHistory.vue?vue&type=script&lang=js"
import style0 from "./equipHistory.vue?vue&type=style&index=0&id=68616c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68616c28",
  null
  
)

export default component.exports